export const CLIENT_API_URL = 'https://abfahrtsmonitor.rnv-online.de/api'
